// extracted by mini-css-extract-plugin
module.exports = {"title":"SkeletonTopNews_title__zADJn","newsArticlesList":"SkeletonTopNews_newsArticlesList__9P9i_"};